<div class="pacer-page-header">
  <h4>C&D Scenarios</h4>
</div>

<div class="card-body">
  <div class="row">
    <p class="k-block">
      <button kendoButton (click)="clickExportAll()" class="k-button" style="margin-right: 5px;">Export All Scenarios</button>
      <button kendoButton (click)="clickExportSelected()" class="k-button" style="margin-right: 5px;" [disabled]="scenariosSelected.length <= 0">Export Selected Scenarios</button>
    </p>
  </div>
  <div class="row">
    <kendo-grid
      [data]="gridData"
      [filter]="state.filter"
      [filterable]="true"
      (dataStateChange)="onDataStateChange($event)"
      [sortable]="{ allowUnsort: allowUnsort, mode: multiple ? 'multiple' : 'single' }"
      [sort]="sort"
      [loading]="isLoading"
      (sortChange)="sortChange($event)"
      style="height: auto; overflow-x: hidden;"
      accesskey="true"
      [selectable]="true"
      [kendoGridSelectBy]="scenarioSelectedKey"
      [(selectedKeys)]="scenariosSelected"
    >
    <kendo-grid-checkbox-column [width]="50"></kendo-grid-checkbox-column>
      <kendo-grid-column field="developmentAreaName" title="Development Area"></kendo-grid-column>
      <kendo-grid-column field="isActiveForOutlook" title="Active for Outlook?" ></kendo-grid-column>
      <div *kendoGridDetailTemplate="let dataItem">
        <app-scenario-data-expansion
          [developmentAreaName]="dataItem.developmentAreaName"
          [isActiveForOutlook]="dataItem.isActiveForOutlook"
        ></app-scenario-data-expansion>
      </div>
    </kendo-grid>
  </div>
</div>
